import styles from "./campaignfilter.module.css";
import { Link } from "react-router-dom";
import { Plus, Search } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";

const CampaignFilter = ({ filterData, setFilterData }) => {
    const { user, isAuthenticated } = useAuth0();

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" value={filterData?.searchKey || ""} onChange={(e) => setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; })} />
            </div>
        </div>
        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("campaign:create") > -1 && <div className={`${styles.FilterSec}`}>
            <Link to={`/communication/campaigns/add`} className={`${styles.AddNoteBu}`}>
                <Plus /> <span>Template</span>
            </Link>
        </div>}
    </div>);
}

export default CampaignFilter;